var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginRegisterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 72,
    height: 72,
    rx: 13.0909,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3018_10374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1066 34.811C34.3919 34.811 37.0648 32.1382 37.0648 28.8529C36.7652 20.9594 25.4468 20.9616 25.1484 28.8529C25.1484 32.1382 27.8212 34.811 31.1066 34.811Z",
    fill: "#4D4949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3172 45.9242V40.9034C34.3172 39.0581 35.0599 37.3564 36.2836 36.1126C29.1716 32.1608 20.0145 37.6124 20.126 45.7909C20.1259 45.7908 20.1259 48.9366 20.1259 48.9366C20.1259 50.5398 21.4226 51.8824 23.0716 51.8824H37.0712C35.3871 50.4445 34.3172 48.307 34.3172 45.9242Z",
    fill: "#4D4949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1077 36.038V23.8327C48.1077 23.584 48.0089 23.3456 47.8331 23.1698L44.8207 20.1574C44.6448 19.9816 44.4064 19.8828 44.1578 19.8828C43.9091 19.8828 43.6708 19.9816 43.4949 20.1574L40.4825 23.1698C40.1164 23.5359 40.1164 24.1295 40.4825 24.4956L41.3258 25.3389L40.4824 26.1823C40.1164 26.5484 40.1164 27.1419 40.4824 27.508L41.3257 28.3513L40.4825 29.1945C40.1164 29.5606 40.1164 30.1541 40.4825 30.5203L41.3259 31.3637L40.4826 32.207C40.3068 32.3827 40.208 32.6212 40.208 32.8698V36.0378C37.923 36.4773 36.1914 38.4917 36.1914 40.9029V45.9236C36.1914 49.2089 38.8642 51.8817 42.1495 51.8817H46.1661C49.4515 51.8817 52.1243 49.2089 52.1243 45.9236V40.9029C52.1243 38.4918 50.3926 36.4774 48.1077 36.038ZM44.1578 46.9945C43.0136 46.9945 42.0829 46.0637 42.0829 44.9195C42.1872 42.1706 46.1289 42.1713 46.2327 44.9195C46.2327 46.0637 45.3019 46.9945 44.1578 46.9945Z",
    fill: "#4D4949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3018_10374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20.125 19.8828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRegisterIcon);
export default __webpack_public_path__ + "static/media/login-register-icon.d5dbe406a5fb9a13d600638f33c40d34.svg";
export { ForwardRef as ReactComponent };